import { I_DEPRESSED, I_GOOD, I_SOSO, I_TERRIBLE, I_VERY_GOOD } from '../types/images';
import { CodeValueType } from '../types/types';

export const PAINSTEP = [
    '아주 약간 이상한 느낌만 있는 정도',
    '크게 움직일 때 저림, 땡김이 있는 정도',
    '움직일 때 욱신거림, 열감이 느껴지는 정도',
    '움직이지 않을때도 통증이 느껴지는 정도',
    '통증 때문에 운동에 크게 지장이 있을 정도',
];

export const PAINTYPE = [
    { code: 'TINGLING', value: '따끔함' },
    { code: 'SENSITIVITY', value: '저림' },
    { code: 'CHILLS', value: '시림' },
    { code: 'STIFFNESS', value: '뻐근함' },
    { code: 'ETC', value: '기타' },
];

export const PAINPERIOD = [
    { code: 'DDAY', value: '당일' },
    { code: 'WITHIN_TEN_DAYS', value: '열흘 내' },
    { code: 'OVER_ONE_MONTH', value: '1개월 이상' },
    { code: 'OVER_THREE_MONTH', value: '3개월 이상' },
];

export const MENSTRUATIONAMOUNT = [
    { code: 'NONE', value: '없음' },
    { code: 'HEAVY', value: '많음' },
    { code: 'LIGHT', value: '적음' },
];

export const PMSPAINTYPE = [
    { code: 'LOWER_ABDOMEN_PAIN', value: '하복부 통증' },
    { code: 'ABDOMINAL_DISTENSION', value: '복부 팽만' },
    { code: 'HEADACHE', value: '두통' },
    { code: 'CHEST_PAIN', value: '가슴 통증' },
    { code: 'MUSCLE_PAIN', value: '근육통' },
    { code: 'PELVIC_PAIN', value: '골반 통증' },
];

export const PMSPAINSTEP = [
    '평소와 다른 민감함을 감지한 정도',
    '큰 움직임에 불편함이 생기는 정도',
    '가벼운(작은) 동작에도 불편함이 생기는 정도',
    '움직일 순 있지만 가만히 있어도 불편한 정도',
    '통증때문에 운동에 크게 지장이 있을 정도',
];

// EMOTIONAL_FLUCTUATIONS // 감정기복
// APPETITE_CHANGES // 식욕변화
// CONSTIPATION // 변비
// DIARRHEA // 설사
// COLD_SWEET // 식은땀
// FEVER_AND_CHILLS // 발열 & 오한
// FATIGUE // 피로함
// NAUSEA_AND_VOMITING // 매스꺼움&구토
export const PMSTYPE = [
    { code: 'EMOTIONAL_FLUCTUATIONS', value: '감정기복' },
    { code: 'APPETITE_CHANGES', value: '식욕변화' },
    { code: 'CONSTIPATION', value: '변비' },
    { code: 'DIARRHEA', value: '설사' },
    { code: 'COLD_SWEET', value: '식은땀' },
    { code: 'FEVER_AND_CHILLS', value: '발열 & 오한' },
    { code: 'FATIGUE', value: '피로함' },
    { code: 'NAUSEA_AND_VOMITING', value: '매스꺼움&구토' },
];

export const CONDITION_TYPE = [
    { code: 'TOP', src: I_VERY_GOOD, text: '최상' },
    { code: 'GOOD', src: I_GOOD, text: '좋음' },
    { code: 'NORMAL', src: I_SOSO, text: '보통' },
    { code: 'SAD', src: I_DEPRESSED, text: '우울한' },
    { code: 'BAD', src: I_TERRIBLE, text: '불쾌한' },
];

export const GENDER_TYPE: CodeValueType<GENDERCODETYPE>[] = [
    { code: 'male', value: '남성' },
    { code: 'female', value: '여성' },
    { code: '', value: '-' },
];
export const GOAL_TYPE: CodeValueType<OnboardingGoal>[] = [
    { code: 'NOT_SET', value: '❓ 미설정' },
    { code: 'WEIGHT_LOSS', value: '⚖️ 체중 감량' },
    { code: 'STRENGTH_FITNESS', value: '💪 근력·체력' },
    { code: 'REHAB_PAIN_MANAGEMENT', value: '🦵 재활·통증' },
    { code: 'CUSTOM', value: '🎯 맞춤형' },
];

export type OnboardingGoal = 'NOT_SET' | 'WEIGHT_LOSS' | 'STRENGTH_FITNESS' | 'REHAB_PAIN_MANAGEMENT' | 'CUSTOM';

export enum OnboardingGoalType {
    NOT_SET = '❓ 미설정',
    WEIGHT_LOSS = '⚖️ 체중 감량',
    STRENGTH_FITNESS = '💪 근력·체력',
    REHAB_PAIN_MANAGEMENT = '🦵 재활·통증',
    CUSTOM = '🎯 맞춤형',
}
// 등록 타입
export const REGISTRATION_TYPE: CodeValueType<string>[] = [
    { code: 'NONE', value: '-' },
    { code: 'NEW', value: '신규' },
    { code: 'RE_REGISTRATION', value: '재등록' },
];

export type GENDERCODETYPE = 'male' | 'female' | '';

// 휴대폰 번호 정규식
export const PHONE_NUMBER_REGEXP = /^01[0-9]{1}-\d{3,4}-\d{4}$/;
// 이메일 정규식
export const EMAIL_REGEXP = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
// YYYY-MM-DD 정규식
export const DATE_REGEXP = /^(19[0-9]{2}|20[0-9]{2})-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;

// 판매 상태 :       //COMPLETED: 완료 | UPGRADE: 업그레이드 | PARTIAL_REFUND: 부분 환불 | FULL_REFUND: 전체 환불 | PARTIAL_PAYMENT: 분할 결제
export const attendanceStatusData = [
    { code: 'COMPLETED', value: '완료' },
    { code: 'UPGRADED', value: '업그레이드' },
    { code: 'PARTIAL_REFUND', value: '부분 환불' },
    { code: 'FULL_REFUND', value: '전체 환불' },
    { code: 'PARTIAL_PAYMENT', value: '분할 결제' },
];

// 회원 구분 :       "isNewSales": true, //  해당 수강권의 신규 / 재등록 여부 (true : 신규 / false : 재등록 )
export const memberStatusData = [
    { code: 'isNewSales', value: '신규' },
    { code: 'isReRegistration', value: '재등록' },
];

// 10줄씩 보기
export const PAGINATIONOPTIONS = [
    { code: '10', value: '10줄씩 보기' },
    { code: '20', value: '20줄씩 보기' },
    { code: '30', value: '30줄씩 보기' },
];
